<template>
  <Button type="primary" :class="[marginBottom]" id="btn" @click="back">{{ $t("common.backtrack") }}</Button>
  <!-- <Button class="backbtn" :class="[marginBottom]" id="btn" @click="back">返回</Button> -->
</template>
<script>
export default {
  name: 'BackBtn',
  props: {
    goBefore: {
      type: Boolean,
      default: true
    },
    marginBottomState: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    marginBottom () {
      return {'mb-4': this.marginBottomState }
    }
  },
  methods: {
    back () {
      if(this.goBefore) this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss">
.backbtn {
  &#btn {
    width: 80px;
    height: 30px;
    background: linear-gradient(to bottom, #4eb5e5 0%, #389ed5 100%);
    border: none;
    border-radius: 5px;
    position: relative;
    border-bottom: 4px solid #2b8bc6;
    color: #fbfbfb;
    font-weight: 600;
    font-family: "Open Sans", sans-serif;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);
    font-size: 14px;
    text-align: right;
    text-indent: 5px;
    box-shadow: 0px 3px 0px 0px rgba(0, 0, 0, 0.2);
    cursor: pointer;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 5px 12px;
    padding-left: 0;
    &::after {
      content: "";
      width: 0;
      height: 0;
      display: block;
      border-top: 12px solid #187dbc;
      border-bottom: 14px solid #187dbc;
      border-right: 12px solid transparent;
      border-left: 16px solid #187dbc;
      position: absolute;
      opacity: 0.6;
      left: 0;
      top: 0;
      border-radius: 5px 0 0 5px;
    }
  }
}
</style>